export const handleOnMount = () => {
  window.document.scrollingElement.scrollTo(0, 0);
};
